import {
  useExportAsCsv,
  useExportAsDoc,
  useExportAsExcel,
  useExportAsFigma,
  useExportAsPdf,
  useExportAsPng,
  useExportAsPrompt,
  useExportAsSitemap,
  useExportAsTxt,
  useExportAsWP,
  useExportAsXml,
  useProjectAccess,
} from '@/hooks'
import { EXPORT_PERMISSION } from '@/permissions/project/definitions'

export const useExportMenu = () => {
  const { hasAccess } = useProjectAccess(EXPORT_PERMISSION.FILE_FORMATS)

  const onClickAiPrompt = useExportAsPrompt()
  const onClickFigma = useExportAsFigma()
  const onClickWP = useExportAsWP()
  const onClickSitemap = useExportAsSitemap()
  const onClickXml = useExportAsXml()
  const onClickPdf = useExportAsPdf()
  const onClickPng = useExportAsPng()
  const onClickCsv = useExportAsCsv()
  const onClickXls = useExportAsExcel()
  const onClickTxt = useExportAsTxt()
  const onClickDoc = useExportAsDoc()

  const publicExportHandlers: Record<string, () => void> = {
    ai_prompt: onClickAiPrompt,
    figma: onClickFigma,
    wordpress: onClickWP,
    sitemap: onClickSitemap,
  }

  const protectedExportHandlers: Record<string, () => void> = {
    xml: onClickXml,
    pdf: onClickPdf,
    png: onClickPng,
    csv: onClickCsv,
    xls: onClickXls,
    txt: onClickTxt,
    doc: onClickDoc,
  }

  const onExport = (type: string) => {
    const publicExportHandler = publicExportHandlers[type]

    if (publicExportHandler) {
      publicExportHandler()
      return
    }

    if (!hasAccess) {
      return
    }

    protectedExportHandlers[type]?.()
  }

  return { onExport }
}
